import type { FormVariant } from '~/constants/form'
import { EventName, PropName } from '~/constants/plausible'

const formVariant = ref<FormVariant>(null)
const { trackEvent } = usePlausible()

/**
 * A reactive count of form variant resetting used for
 * component keys to rerender on form variant set.
 */
const remountCount = ref(0)

export function useFormVariant() {
  return {
    formVariant,
    remountCount,
    setFormVariant
  }
}

function setFormVariant(variant: FormVariant) {
  remountCount.value++
  formVariant.value = variant
  trackEvent(EventName.SET_FORM_VARIANT, {
    props: { [PropName.FORM_VARIANT]: variant }
  })
}
